/** Coerce Firestore Timestamp, JS Date, or ISO string to a Date. */
export function coerceFirestoreDate(value: unknown): Date {
  if (value instanceof Date) {
    return value;
  }
  if (value && typeof value === 'object' && 'toDate' in value) {
    const toDate = (value as { toDate?: () => Date }).toDate;
    if (typeof toDate === 'function') {
      return toDate.call(value);
    }
  }
  if (typeof value === 'string' || typeof value === 'number') {
    return new Date(value);
  }
  return new Date(Number.NaN);
}

export function isValidDate(date: Date): boolean {
  return !Number.isNaN(date.getTime());
}
